import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import DataguardHeatmap from "../DataguardHeatmap";
import SmallHeatmap from "../SmallHeatmap";
import FullscreenIcon from "@material-ui/icons/Fullscreen";
import { GET_PUBLIC_DATA_ASSETS_COUNT } from "../../Utility/DataguardConstant";
import CustomBarChart from "./CustomPublicBarChart";
import { numFormatter } from "../../../../components/common/Dashboard/utils";

const PublicDataCard = ({ showExpandedView, isPopup = false, onClick, style }) => {
  const dispatch = useDispatch();
  const dataguardHeaderData = useSelector(
    (state) => state.DataguardReducer.dataguardHeaderData,
  );
  const publicDataAssetsCount = useSelector(
    (state) => state.dataTagReducer.publicDataAssetsCount,
  );
  const publicAccess = dataguardHeaderData?.publicAccess;
  const totalAssetsCount = useSelector(
    (state) => state.DataguardReducer.totalAssetsCount,
  );
  const fromTimeStamp = useSelector(
    (state) => state.DataguardReducer.fromTimeStamp,
  );
  const toTimeStamp = useSelector(
    (state) => state.DataguardReducer.toTimeStamp,
  );

  useEffect(() => {
    // Fetch public data assets count when fromTimeStamp or toTimeStamp changes
    if (fromTimeStamp && toTimeStamp) {
      // Dispatch an action to fetch public data assets count
      dispatch({
        type: GET_PUBLIC_DATA_ASSETS_COUNT,
        payload: { fromTimeStamp, toTimeStamp },
      });
    }
  }, [dispatch, fromTimeStamp, toTimeStamp]);

  // Format numbers with US commas
  const formattedTotalAssetsCount = parseInt(
    totalAssetsCount || "0",
  ).toLocaleString("en-US");
  const formattedPublicAssetsCount = parseInt(
    publicAccess?.alertCount || "0",
  ).toLocaleString("en-US");
  const formattedActivitiesCount = parseInt(
    publicDataAssetsCount?.totalActivities || 0,
  ).toLocaleString("en-US");

  const chartData = Array.isArray(publicDataAssetsCount?.files)
    ? publicDataAssetsCount.files.map((file) => ({
        name: file.filename,
        count: file.activitiesCount,
      }))
    : [];

  return (
    <div className="column-card public-data-card" style={style}>
      <div className="details-container" onClick={onClick}>
        <div className="left-details">
          <div className="left-details-container public">
            <div className="icon-container">
              <img src="/dashboardIcons/publicActive.svg" alt="Location Icon" />
              <span className="ico-label">Public Data Assets</span>
            </div>
            <div className="left-details-txt">
              <span>Total # of Assets</span>
              <span className="no-locs">{numFormatter(formattedTotalAssetsCount || 0)}</span>
            </div>
            <div className="left-details-txt">
              <span>Total # of Public Assets</span>
              <span className="loc-alert">
                {numFormatter(formattedPublicAssetsCount || 0)}
              </span>
            </div>
            <div className="left-details-txt">
              <span>Total # of Activities for Public Assets</span>
              <span className="loc-alert">{numFormatter(formattedActivitiesCount || 0)}</span>
            </div>
          </div>
        </div>
        <div className="right-chart public">
          <CustomBarChart data={chartData} isPopup={isPopup} />
        </div>
      </div>
      {!isPopup ? (
        <div className='fullscreen-icon roles' onClick={(e) => { showExpandedView('publicData'); e.stopPropagation(); }}>
          <FullscreenIcon fontSize="small" />
        </div>
      ) : (
        null
      )}
    </div>
  );
};

export default PublicDataCard;